import React, { useEffect } from 'react';

function App() {
  useEffect(() => {
    window.location.href = 'https://feddersconstruction.sharepoint.com/sites/CommHub/';
  }, []);

  return null;
}

export default App;